export default function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
// module id = 951
// module chunks = 0 1 2 3 4 5 6 7 8